import { render, staticRenderFns } from "./NutritionalScreeAssessResult.vue?vue&type=template&id=58298a3d&scoped=true"
import script from "./NutritionalScreeAssessResult.vue?vue&type=script&lang=js"
export * from "./NutritionalScreeAssessResult.vue?vue&type=script&lang=js"
import style0 from "./NutritionalScreeAssessResult.vue?vue&type=style&index=0&id=58298a3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58298a3d",
  null
  
)

export default component.exports